import { render, staticRenderFns } from "./IconeAssinarDocumento.vue?vue&type=template&id=3cf49c4b"
import script from "./IconeAssinarDocumento.vue?vue&type=script&lang=js"
export * from "./IconeAssinarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports